import React from 'react';
import { Header } from 'semantic-ui-react';
import { convertNumberStringToDate } from '../../../../../../../util/constants';

const MonthlyHeader = ({ cbpDailyData, statementPrintDate, formatMoney }) => {
  return (
    <div className='cbpPaymentSectionHeaderDiv'>
      <div className='headerSectionFour'>
        <Header className='cbpHeaderText top' as='h5'>
          STATEMENT NUMBER
        </Header>
        <Header className='cbpHeaderText' as='h4'>
          {cbpDailyData?.statementNumber}
        </Header>
      </div>
      <div className='headerSectionFour'>
        <Header className='cbpHeaderText top' as='h5'>
          PRINT DATE
        </Header>
        <Header className='cbpHeaderText' as='h4'>
          {convertNumberStringToDate(statementPrintDate, true, false)}
        </Header>
      </div>
      <div className='headerSectionFour'>
        <Header className='cbpHeaderText top' as='h5'>
          TOTAL AMOUNT DUE
        </Header>
        <Header className='cbpHeaderText' as='h4'>
          $
          {formatMoney(
            (parseFloat(cbpDailyData?.totalAmountDue) / 100).toFixed(2)
          )}
        </Header>
      </div>
    </div>
  );
};

export default MonthlyHeader;
